<template>
  <!--
    	作者：wangxw
    	时间：2019-10-26
    	描述：产品分类-修改
    -->
  <el-dialog title="选择模板" :visible.sync="dialogVisible" @close="handleClose" :close-on-click-modal="false"
    :close-on-press-escape="false">
    <el-form size="small" :model="form" ref="form">
      <el-form-item label="模板">
         <el-select 
          v-model="form.print_temp_id" 
          placeholder="请选择模板"
        >
          <el-option 
            v-for="cat in FormList"
            :key="cat.print_temp_id"
            :label="cat.title"
            :value="cat.print_temp_id"  
          ></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="setForm" :loading="loading" :disabled="!form.print_temp_id">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
  import OrderApi from '@/api/order.js';
  export default {
    components: {
      OrderApi
    },
    data() {
      return {
        form: {
          print_temp_id: 0,
        },
        /*是否显示*/
        dialogVisible: false,
        loading: false,
      };
    },
    props: ['open_form', 'order_id','FormList'],
    created() {
      this.dialogVisible = this.open_form;
      // this.form = this.FormList;
    },
    methods: {
      // handleTemplateChange(id) {
      //   const template = this.formList.find(item => item.print_temp_id === id);
      // },
       setForm() {
          let self = this;
          OrderApi.setForm({
            order_id: self.order_id,
            print_temp_id: self.form.print_temp_id
          }, true)
          .then(data => {
             this.loading = false; // 结束加载
            console.log(data);
            this.$message.success('模板选择成功！');
            this.handleClose(true); 
          })
          .catch(error => {
            this.loading = false; 
            this.$message.error('模板选择失败，请稍后重试。'); // 给用户失败提示
            this.handleClose(false); 
          });
       
      },
      handleClose(isSuccess) {
        this.dialogVisible = false;
        // 向父组件发送事件，传递关闭的类型
        this.$emit('closeDialog', {
          type: isSuccess ? 'success' : 'cancel',
          openDialog: false,
          // 可以把选中的模板ID也传回去，方便父组件使用
          selectedTemplateId: isSuccess ? this.form.print_temp_id : null 
        });
      },
      
    }
  };
</script>

<style>
  .img {
    margin-top: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/views/order/order/SelectForm.vue